import React, { useMemo } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from '@sakura/ui';
import { AuthProvider, useAuth } from './context/AuthContext';
import { createApolloClient } from './lib/apollo';
import './index.css';

// Pages
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/Dashboard';
import ScheduleManagement from './pages/ScheduleManagement';
import StaffManagement from './pages/StaffManagement';
import LeaveManagement from './pages/LeaveManagement';
import ReportsPage from './pages/ReportsPage';
import SettingsPage from './pages/SettingsPage';

const AppContent: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/dashboard"
          element={isAuthenticated ? <DashboardPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/schedule"
          element={isAuthenticated ? <ScheduleManagement /> : <Navigate to="/login" />}
        />
        <Route
          path="/staff"
          element={isAuthenticated ? <StaffManagement /> : <Navigate to="/login" />}
        />
        <Route
          path="/leave"
          element={isAuthenticated ? <LeaveManagement /> : <Navigate to="/login" />}
        />
        <Route
          path="/reports"
          element={isAuthenticated ? <ReportsPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/settings"
          element={isAuthenticated ? <SettingsPage /> : <Navigate to="/login" />}
        />
      </Routes>
    </BrowserRouter>
  );
};

function App() {
  const client = useMemo(() => createApolloClient(), []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ApolloProvider client={client}>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </ApolloProvider>
    </ThemeProvider>
  );
}

export default App;
